/**
 * Cookie storage keys
 */
export const COOKIE_KEYS = {
  /** GeoIP bar dismissed by user (365 days) */
  USER_CONFIRMED_MESSAGE: 'isUserConfirmedMessage',
  /** User's country from Cloudflare (external) */
  CLOUDFLARE_COUNTRY: 'cf-ipcountry',
  /** User's selected country (365 days) */
  SELECTED_COUNTRY: 'cf-ipdfcountry',
  /** Language bar dismissed for session (session cookie) */
  HIDE_LANGUAGE_BAR_SESSION: 'hideLanguageBarForSession',
  /** VAT bar has been viewed (session cookie) */
  HAS_SEEN_VAT_BAR: 'hasSeenVatSelectionBar',
} as const

/**
 * LocalStorage keys
 */
export const LOCAL_STORAGE_KEYS = {
  /** Language bar preference (7 days) */
  HIDE_LANGUAGE_BAR: 'hideLanguageBar',
  /** VAT selection bar preference (30 days) */
  HIDE_VAT_SELECTION_BAR: 'hideVatSelectionBar',
} as const

/**
 * Storage TTL (Time-To-Live) values in days
 */
export const STORAGE_TTL = {
  ONE_YEAR: 365,
  ONE_MONTH: 30,
  ONE_WEEK: 7,
} as const

/**
 * Combined storage keys for backward compatibility
 */
export const STORAGE_KEYS = {
  ...COOKIE_KEYS,
  ...LOCAL_STORAGE_KEYS,
} as const
